<template>
  <popup class="" v-model="isActive">
    <div class="messageMode">
      <div class="saveMessage">
        <div class="icon-x" @click="determine('on-close')"></div>
        <h5>{{ title }}</h5>
        <p>{{ text }}</p>
        <span class="btn-ok" @click="determine('on-action')">{{ action }}</span>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from './Popup'
export default {
  components: {
    Popup
  },
  props: {
    title: {
      type: String,
      default: function () {
        return "保存提示";
      }
    },
    text: {
      type: String,
      default: function () {
        return "信息未保存，请先点确定保存";
      }
    },
    action: {
      type: String,
      default: function () {
        return "确认";
      }
    },
    value: Boolean,
  },
  data () {
    return {
      isActive: this.value
    }
  },
  methods: {
    determine (operation) {
      this.$emit(operation);
      this.isActive = false;
    }
  },
  watch: {
    isActive (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.isActive = val;
    }
  }
}
</script>
<style lang="scss">
@import "../../static/sass/_variable.scss";
.messageMode {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;

  .saveMessage {
    position: absolute;
    top: 6.2rem;
    /*left:50%;*/
    /*width:268px;*/
    left: 10%;
    width: 80%;
    height: 151px;
    /*<!--transform:translateX(-50%);-->*/
    text-align: center;
    background-color: #ffffff;
    color: #333333;
    z-index: 100;

    h5 {
      font-size: 15px;
      margin: 18px 0px;
      font-weight: bold;
    }
    p {
      font-size: 13px;
    }
    span {
      display: block;
      margin: 25px auto 18px auto;
      width: 8rem;
      height: 1.85rem;
      border-radius: 4px;
      font-size: 15px;
      line-height: 1.85rem;
      background-color: $main-yellow;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// MessageConfirm.vue?99f273ca